import { RootState } from '../../main/store/main.store.ts';

export const selectIsGodMode = (state: RootState): boolean => state.lesson.isGodMode;
